import React from "react";

const BASE = import.meta.env.BASE_URL;

function Col({ name, card, isWinner }) {
  return (
    <div className="col-12 col-lg-2">
      <div className="casino-result-cards">
        {isWinner && (
          <div className="casino-result-cards-item">
            <img src={`${BASE}img/winner.png`} className="winner-icon" alt="" />
          </div>
        )}{" "}
        <div className="d-inline-block">
          <h4>{name}</h4>{" "}
          <div className="casino-result-cards-item">
            <img src={`${BASE}img/cards/${card}.png`} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

/**
 * Reference result body for 20-20 D T L (dtl20 / vdtl20): Dragon / Tiger / Lion cards
 * (trophy for win 1 / 21 / 41) + rdesc "winner#red-black#odd-even#card".
 */
export default function DtlResultBody({ t1 }) {
  const cards = t1?.card ? String(t1.card).split(",") : [];
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  const win = String(t1?.win ?? "");
  const rows = [
    ["Winner", desc[0]],
    ["Red/Black", desc[1]],
    ["Odd/Even", desc[2]],
    ["Card", desc[3]],
  ];
  return (
    <div data-btl-result="" className="row row5 dtl20-result text-center">
      <Col name="Dragon" card={cards[0]} isWinner={win === "1"} />{" "}
      <Col name="Tiger" card={cards[1]} isWinner={win === "21"} />{" "}
      <Col name="Lion" card={cards[2]} isWinner={win === "41"} />{" "}
      <div className="col-12 col-lg-6">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            {rows.map(([label, value], i) => (
              <React.Fragment key={label}>
                {i > 0 && " "}
                <div className="casino-result-desc-item">
                  <div>{label}</div> <div>{value}</div>
                </div>
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
